module.exports = __webpack_public_path__ + "img/TurningStool7.5a79c547.jpg";